$(function () {
    // mobile functionality
    $('#nav-icon-x').click(function () {
        $(this).toggleClass('open');
    });

    // set the header container to the height of the header
    var headerContainer = $('.wt-header');
    var headerIn = headerContainer.find('.header__in');
    var navPos = headerIn.offset().top;
    var searchBar = $('.search-bar');

    headerContainer.css({
        'height': headerIn.css('height')
    });

    // set fixed top for on scroll
    $(window).scroll(function () {
        // get scroll position from top of the page
        var scrollPos = $(this).scrollTop();

        // check if scroll position is >= the nav position
        if (scrollPos > navPos) {
            headerIn.addClass('fixed-top');

            searchBar.addClass('fixed-top');
            searchBar.css('top', headerIn.css('height'));
        }
        else {
            headerIn.removeClass('fixed-top');

            searchBar.removeClass('fixed-top');
            searchBar.css('top', 'unset');
        }
    });

    // mobile dropdown functionality
    $('.dropdown-toggle').click(function (e) {
        e.preventDefault();

        var currentToggle = $(this);
        var currentDropdown = $(this).parent().siblings('.dropdown-menu');

        // close all other dropdowns
        $('.dropdown-toggle').each(function () {
            if ($(this).attr('id') != currentToggle.attr('id')) {
                $(this).removeClass('show');
            }
        });

        $('.dropdown-menu').each(function () {
            if ($(this).attr('aria-labelledby') != currentDropdown.attr('aria-labelledby')) {
                $(this).removeClass('show');
            }
        });

        currentToggle.toggleClass('show');
        currentDropdown.toggleClass('show');
    });

    // nested dropdown functionality
    $('.nested-dropdown-toggle').click(function (e) {
        e.preventDefault();

        var currentToggle = $(this);
        var currentDropdown = $(this).parent().siblings('.nested-dropdown-menu');

        // close all other dropdowns
        $('.nested-dropdown-toggle').each(function () {
            if ($(this).attr('id') != currentToggle.attr('id')) {
                $(this).removeClass('show');
            }
        });

        $('.nested-dropdown-menu').each(function () {
            if ($(this).attr('aria-labelledby') != currentDropdown.attr('aria-labelledby')) {
                $(this).removeClass('show');
            }
        });

        currentToggle.toggleClass('show');
        currentDropdown.toggleClass('show');
    });

    // custom language dropdown
    $(document).on('click', '.current-lang', function (e) {
        e.preventDefault();

        $(this).parent().siblings('.languages').toggleClass('show');
    });

    $(document).on('click', '.language-dropdown .language', function (e) {
        e.preventDefault();

        var a = $(this);

        $.ajax({
            url: "/Language/ChangeLanguage",
            method: "GET",
            data: { languageCode: a.data('language-code') }
        }).done(function () {
            window.location.href = a.attr('href');
        });

    });

    $(document).click(function (e) {
        var languages = $('.languages');

        if (languages.hasClass('show') && !$(e.target).hasClass('current-lang')) {
            languages.removeClass('show');
        }
    });
});